/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { FlexRow, FlexCol } from 'sarsaparilla';
import { ItemsPlaceholder } from './ItemsPlaceholder';
import ContestCard from '../ContestCard';
import { slugify } from '../../utils/storyUtils';

export default function Items({ items, isLoading }) {
    if (isLoading) {
        return (
            <FlexRow>
                {[...Array(16)].map((x, i) => (
                    <ItemsPlaceholder key={i} />
                ))}
            </FlexRow>
        );
    }

    const storyGalleryBlocks = items.map((item, index) => {
        let media = {};
        if (item.media?.length > 0) {
            media = item.media[0];
        }

        const locations =
            item.locations?.map((l) => {
                return l.location_name;
            }) || [];

        return (
            <FlexCol sm={6} md={4} xl={3} className="mb-4" key={index}>
                <ContestCard
                    headingLevel={3}
                    imagePath={media.url}
                    imageAlt={media.title}
                    heading={item.title}
                    categoryTags={[item.final_category]}
                    href={`/shareyourstory/story/${slugify(item.title)}/${item.story_id}`}
                    locations={locations}
                    author={`${item.first_name} ${item.last_name}`}
                    submissionDate={
                        item.submitted_date
                            ? format(new Date(item.submitted_date), 'MMMM dd, yyyy')
                            : ''
                    }
                    winnerTags={item.prizes_objs || []}
                />
            </FlexCol>
        );
    });

    return <FlexRow>{storyGalleryBlocks}</FlexRow>;
}

Items.propTypes = {
    items: PropTypes.array,
    isLoading: PropTypes.bool,
};
